export type TabSpan = { start: number; size: number };
export type TabAxis = "vertical" | "horizontal";

export const GELATIN_DURATION = 540;
const clamp = (n: number) => Math.min(1, Math.max(0, n));
const easeOut = (t: number) => 1 - (1 - t) ** 3;
const easeInOut = (t: number) => t < .5 ? 4 * t ** 3 : 1 - (-2 * t + 2) ** 3 / 2;

/** Separate edge clocks create the stretch; a small damped ripple settles it. */
export function gelatinFrames(from: TabSpan, to: TabSpan, axis: TabAxis): Keyframe[] {
  const forward = to.start > from.start;
  const distance = Math.abs(to.start - from.start);
  const rippleSize = Math.min(3.5, distance * .025);
  return Array.from({ length: 46 }, (_, i) => {
    const offset = i / 45;
    const time = offset * GELATIN_DURATION;
    const lead = easeOut(clamp(time / 235));
    const trail = easeInOut(clamp((time - 85) / 295));
    const settle = clamp((time - 235) / (GELATIN_DURATION - 235));
    const ripple = Math.sin(settle * Math.PI * 3) * (1 - settle) ** 2 * rippleSize;
    const start = from.start + (to.start - from.start) * (forward ? trail : lead) - ripple;
    const fromEnd = from.start + from.size;
    const end = fromEnd + (to.start + to.size - fromEnd) * (forward ? lead : trail) + ripple;
    const compression = Math.sin(offset * Math.PI) ** 2 * Math.min(2.5, distance * .012);
    return axis === "horizontal"
      ? { offset, left: `${start}px`, width: `${Math.max(1, end - start)}px`, marginTop: `${compression}px` }
      : { offset, top: `${start}px`, height: `${Math.max(1, end - start)}px`, marginLeft: `${compression}px` };
  });
}
